import { showFailed } from "../Components/CommonComponents/SweetAlert";
import axiosInstance from "../Interceptor/AxiosInstanceInterceptor";

export const getDashboardData = async () => {
  try {
    const response = await axiosInstance.get(`/dashboard/allBank`);
    const data = response.data;
    if (response.status === 200) {
      return data;
    } else {
      showFailed("Failed...", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed...", `${error.response.data.error[0]}`);
  }
};

export const maintenanceSchedule = async (dataToSend) => {
  try {
    const response = await axiosInstance.post(
      `/dashboard/schedule_maintenance`,
      dataToSend
    );
    const data = response.data;
    if (response.status === 200) {
      return data;
    } else {
      showFailed("Failed...", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed...", `${error.response.data.error[0]}`);
  }
};

export const getMaintenanceData = async () => {
  try {
    const response = await axiosInstance.get(
      `/dashboard/get_schedule_maintenance`
    );
    const data = response.data;
    if (response.status === 200) {
      return data;
    } else {
      showFailed("Failed...", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed...", `${error.response.data.error[0]}`);
  }
};

// Total Users

export const getTotalUsersList = async (isExport, page, searchQuery, role) => {
  let query;
  if (!isExport) {
    if (searchQuery.length > 0 || page > 1) {
      if (role === "user") {
        query = `userPage=${page}&user=true&search=${searchQuery}`;
      } else {
        query = `orgPage=${page}&entity=true&search=${searchQuery}`;
      }
    } else {
      query = "";
    }
  } else {
    query = `getAllData=true`;
  }
  try {
    const response = await axiosInstance.get(`/user/userAllList?${query}`);
    const data = response.data;
    if (response.status === 200) {
      return data?.response;
    } else {
      showFailed("Failed...", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed...", `${error.response.data.error[0]}`);
  }
};

// New Users

export const getNewUsersList = async (isExport, page, searchQuery, role) => {
  let query;
  if (!isExport) {
    if (searchQuery.length > 0 || page > 1) {
      if (role === "user") {
        query = `userPage=${page}&user=true&search=${searchQuery}`;
      } else {
        query = `orgPage=${page}&entity=true&search=${searchQuery}`;
      }
    } else {
      query = "";
    }
  } else {
    query = `getAllData=true`;
  }
  try {
    const response = await axiosInstance.get(
      `/user/lastMonthUserList?${query}`
    );
    const data = response.data;
    if (response.status === 200) {
      return data?.response;
    } else {
      showFailed("Failed...", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed...", `${error.response.data.error[0]}`);
  }
};

export const getAllLoanList = async (isExport, page, searchQuery) => {
  let query;
  if (!isExport) {
    query = `search=${searchQuery}&page=${page}`;
  } else {
    query = `getAllData=true`;
  }
  try {
    const response = await axiosInstance.get(`/loan?${query}`);
    const data = response.data;
    if (response.status === 200) {
      console.log("Dta......")
      return data;
    } else {
      showFailed("Failed", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed", `${error.response.data.error[0]}`);
  }
};

export const getAllDeliveryDefault = async (isExport, page, searchQuery) => {
  let query;
  if (!isExport) {
    query = `search=${searchQuery}&page=${page}`;
  } else {
    query = `getAllData=true`;
  }
  try {
    const response = await axiosInstance.get(`/loan?${query}`);
    const data = response.data;
    if (response.status === 200) {
      console.log("Dta......")
      return data;
    } else {
      showFailed("Failed", `${response.status}`);
    }
  } catch (error) {
    showFailed("Failed", `${error.response.data.error[0]}`);
  }
};
